// extracted by mini-css-extract-plugin
export default {"snake-wrapper":"Snake_snake-wrapper__jVjZv","snake-container":"Snake_snake-container__gg6BN"};